module.exports = __webpack_public_path__ + "static/media/brand-refresh-labeledaddress.f66bc588.svg";